import { render, staticRenderFns } from "./businessTags.vue?vue&type=template&id=67038088&"
import script from "./businessTags.vue?vue&type=script&lang=js&"
export * from "./businessTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67038088')) {
      api.createRecord('67038088', component.options)
    } else {
      api.reload('67038088', component.options)
    }
    module.hot.accept("./businessTags.vue?vue&type=template&id=67038088&", function () {
      api.rerender('67038088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/businessTags.vue"
export default component.exports